import { render, staticRenderFns } from "./Catalogos.vue?vue&type=template&id=424ec07b&"
import script from "./Catalogos.vue?vue&type=script&lang=js&"
export * from "./Catalogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports